import axios from 'app/axiosInstance'

export const getCollectionDetails = id => {
    return axios().get(`v1/collections/${id}/studies`)
}
